import { render } from "./Contato.vue?vue&type=template&id=8db2f08c&scoped=true&bindings={\"name\":\"setup\",\"phone\":\"setup\",\"email\":\"setup\",\"message\":\"setup\",\"clearAllInputs\":\"setup\"}"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"

import "./Contato.vue?vue&type=style&index=0&lang=scss"
import "./Contato.vue?vue&type=style&index=1&id=8db2f08c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8db2f08c"

export default script